export default __webpack_public_path__ + "static/media/ski.c31c0c5b.webp";